import { render, staticRenderFns } from "./ErrorBoundary.vue?vue&type=template&id=dd97b212&scoped=true&"
import script from "./ErrorBoundary.vue?vue&type=script&lang=js&"
export * from "./ErrorBoundary.vue?vue&type=script&lang=js&"
import style0 from "./ErrorBoundary.vue?vue&type=style&index=0&id=dd97b212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd97b212",
  null
  
)

export default component.exports